<template>
	<div class="lzExcel">
		<gc-spread-sheets class="sample-spreadsheets" @workbookInitialized="initSpread" style="width: 100%;height: 100%;">
		    <gc-worksheet>
		    </gc-worksheet>
		</gc-spread-sheets>
	</div>
</template>

<script>
	let that
	import "@grapecity/spread-sheets/styles/gc.spread.sheets.excel2016colorful.css";
	import * as GC from "@grapecity/spread-sheets";
	import "@grapecity/spread-sheets-vue";
	import { IO } from "@grapecity/spread-excelio";
	import {jsonData} from './data';
	import {
		mapGetters
	} from 'vuex'
	export default {
		computed: {
			...mapGetters(['api', 'userInfo']),
		},
		name: 'lzExcel',
		props: {
			datas:null,
		},
		data() {
			return {
				spread:null,
			}
		},
		mounted() {
			that = this
			this.excelIO = new IO();
			
		},
		watch:{
			datas(){
				console.log(this.datas);
				const blob = new Blob([this.datas], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
				this.excelUrl=blob
				this.seeFn()
			}
		},
		methods: {
			initSpread: function (spread) {
				this.spread = spread;
				// 为了提高文件导入的速度，你可以使用calcOnDemand属性来指定是否仅在需要时才计算公式
				spread.options.calcOnDemand = true;
			},
			seeFn(){
				console.log(this.excelUrl);
				this.excelIO.open(this.excelUrl, (json)=> {
				    console.log(json);
					// spread.fromJSON(json, {
					//     incrementalLoading: {
					//         loading: function (progress, args) {
					//             progress = progress * 100;
					//             loadingStatus.value = progress;
					//             console.log("current loading sheet", args.sheet && args.sheet.name());
					//         },
					//         loaded: function () {
					//         }
					//     }
					// });
					this.spread.fromJSON(json);
				},(e)=> {
					// process error
					console.log(e);
					this.$message.warning('暂不支持xls格式，仅支持xlsx格式，请下载查看')
				}, {
					password: 0
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.lzExcel{
		width: 100%;height: 100%;overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/lzExcel/lzExcel.vue